export default "https://cdn-static.gokick.com/assets/31d35e8a0a5d253fd42fea745a10067c9b91f7ab/images/sleep-blueberry.4c08b7b0b460cc7a3bc9f6ddf7107552.png";